import { render, staticRenderFns } from "./CancelIcon.vue?vue&type=template&id=6f20eef1&scoped=true"
import script from "./CancelIcon.vue?vue&type=script&lang=js"
export * from "./CancelIcon.vue?vue&type=script&lang=js"
import style0 from "./CancelIcon.vue?vue&type=style&index=0&id=6f20eef1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f20eef1",
  null
  
)

export default component.exports